var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcThaydoi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-thaydoi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-Final",
    transform: "translate(-224.000000, -264.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(23.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(177.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(11.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-thaydoi",
    transform: "translate(13.571429, 12.571429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9583333,0 L5.04166667,0 C2.26233333,0 0,2.26141667 0,5.04166667 C0,7.82191667 2.26233333,10.0833333 5.04166667,10.0833333 L16.9583333,10.0833333 C19.7376667,10.0833333 22,7.82191667 22,5.04166667 C22,2.26141667 19.7376667,0 16.9583333,0 Z M5.04166667,7.33333333 C3.77758333,7.33333333 2.75,6.30483333 2.75,5.04166667 C2.75,3.7785 3.77758333,2.75 5.04166667,2.75 C6.30575,2.75 7.33333333,3.7785 7.33333333,5.04166667 C7.33333333,6.30483333 6.30575,7.33333333 5.04166667,7.33333333 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9583333,11.9166667 L5.04166667,11.9166667 C2.26233333,11.9166667 0,14.1780833 0,16.9583333 C0,19.7385833 2.26233333,22 5.04166667,22 L16.9583333,22 C19.7376667,22 22,19.7385833 22,16.9583333 C22,14.1780833 19.7376667,11.9166667 16.9583333,11.9166667 Z M16.9583333,19.25 C15.69425,19.25 14.6666667,18.2215 14.6666667,16.9583333 C14.6666667,15.6951667 15.69425,14.6666667 16.9583333,14.6666667 C18.2224167,14.6666667 19.25,15.6951667 19.25,16.9583333 C19.25,18.2215 18.2224167,19.25 16.9583333,19.25 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThaydoi);
export default __webpack_public_path__ + "static/media/ic-thaydoi.c38b272d302d7b374542ab66f7c56aa6.svg";
export { ForwardRef as ReactComponent };